import { place } from "./place.ts";

export const drawer = { label: "Escala", href: place.path };
